/** @internal */
export const MIN_CROP_SIZE = 8
